// extracted by mini-css-extract-plugin
module.exports = {"small":"Prix_small__3Q1mm","big":"Prix_big__31dwq","na":"Prix_na__19iyc"};